import { useCheckGPTGameStatus } from 'src/EXPERIMENTAL_LIB/api/gpt/useCheckGPTGameStatus';
import { GPTGameNameType } from '../types';

export function useAreAllGamesAvailable(): Record<GPTGameNameType, boolean> & {
  areAllGamesAvailable: boolean;
} {
  const dailyBonus = useCheckGPTGameStatus({ gameName: 'dailyBonus' });
  const luckyCard = useCheckGPTGameStatus({ gameName: 'cardGame' });
  const luckyPigeon = useCheckGPTGameStatus({ gameName: 'birdGame' });
  const wheelOfFortune = useCheckGPTGameStatus({ gameName: 'wheelOfFortune' });
  const vendingMachine = useCheckGPTGameStatus({ gameName: 'vendingMachine' });

  return {
    areAllGamesAvailable:
      dailyBonus.isAvailable ||
      luckyCard.isAvailable ||
      luckyPigeon.isAvailable ||
      wheelOfFortune.isAvailable ||
      vendingMachine.isAvailable,
    wheelOfFortune: wheelOfFortune.isAvailable,
    cardGame: luckyCard.isAvailable,
    dailyBonus: dailyBonus.isAvailable,
    birdGame: luckyPigeon.isAvailable,
    vendingMachine: vendingMachine.isAvailable,
    oneReelSlot: false
  };
}
